/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_DescriptionInputs */



/**
* | output |
* | --- |
* | "Please select your media source and enter a project name." |
*
* @param {New_Project_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_description = /** @type {((inputs?: New_Project_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner votre source media et entrer un nom de projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie Ihre Medienquelle aus und geben Sie einen Projektnamen ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la fonte multimediale e inserisci un nome per il progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите источник медиафайлов и введите название проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione su fuente de medios e ingrese un nombre de proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择您的媒体来源并输入项目名称。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディア ソースを選択し、プロジェクト名を入力してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया अपना मीडिया स्रोत चुनें और प्रोजेक्ट का नाम दर्ज करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione sua fonte de mídia e insira o nome do projeto.")
	return /** @type {LocalizedString} */ ("Please select your media source and enter a project name.")
});